module.exports = __webpack_public_path__ + "static/media/bacon-egger-mobile-250-en.3e9c8adb.jpg";